import React from 'react';
import ApexCirclesRail from './dashboard/ApexCirclesRail';
import LeftRail from './dashboard/LeftRail';

/**
 * APEX v7.8.4 — GlobalRails
 *
 * Regroupe les 2 rails (gauche : Mission+Patch · droite : Ranking/APEX/Saison)
 * et les rend disponibles au niveau GLOBAL de l'app (tous les onglets),
 * sauf Coaching (doublon avec l'APEX Score détaillé de cet onglet).
 *
 * Les rails sont en position fixed, ils se superposent au contenu sans
 * impacter le layout des onglets.
 */
export default function GlobalRails({
  activeTab,
  games,
  allGames,
  userSettings,
  rankSnapshots,
  seasonObjective,
  onSaveSeasonObjective,
  apexTiers,
  dailyMission,
  activeFilter,
  onSetFilter,
  onSwapMission,
  onSkipMission
}) {
  // v7.8.5 : les rails sont affichés sur TOUS les onglets (Coaching inclus,
  // conformément au choix utilisateur — assumé même si l'APEX Score y est
  // déjà détaillé).
  const gamesForRails = Array.isArray(allGames) ? allGames : (games || []);

  return (
    <>
      <ApexCirclesRail
        games={gamesForRails}
        userSettings={userSettings}
        rankSnapshots={rankSnapshots}
        seasonObjective={seasonObjective}
        onSaveSeasonObjective={onSaveSeasonObjective}
        apexTiers={apexTiers}
      />
      <LeftRail
        games={gamesForRails}
        dailyMission={dailyMission}
        activeFilter={activeFilter}
        onSetFilter={onSetFilter}
        onSwapMission={onSwapMission}
        onSkipMission={onSkipMission}
      />
    </>
  );
}
